import { Component, Input } from '@angular/core';
import { DsModule } from '@levelaccess/design-system';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EditWorkspaceComponent } from '@client/app/pages/public/portfolio/edit-workspace/edit-workspace.component';
import { CommonPipesModule } from '@client/app/shared/common-pipes.module';
import { IWorkspace } from '@shared/interfaces/workspace.interface';

@Component({
  selector: 'app-edit-workspace-modal',
  templateUrl: './edit-workspace-modal.component.html',
  styleUrl: './edit-workspace-modal.component.scss',
  imports: [DsModule, EditWorkspaceComponent, CommonPipesModule],
  standalone: true,
})
export class EditWorkspaceModalComponent {
  @Input() workspaceId: string;
  @Input() workspaceName: string;
  @Input() workspaceDescription: string;

  constructor(public readonly modal: NgbActiveModal) {}

  onWorkspaceEdited(workspace: IWorkspace): void {
    this.modal.close(workspace);
  }

  onCancel(): void {
    this.modal.dismiss();
  }
}
